import React, { Component } from 'react';
import client from './../../utils/apolloClient';
import getData from './../../data-services/api';
import { getUser } from './../../data-services/queries';
import gql from 'graphql-tag';
import StarRatings from 'react-star-ratings';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import './Fevicryl.css';
import Loader from './../../components/CustomLoader';
import { FaRegBookmark } from 'react-icons/fa6';
import { RiShareForward2Line } from 'react-icons/ri';
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';

export default class FevicrylDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            FCPRating: 0,
            productData: {
                craft_category__c: 'Best out of waste ',
                id: '25',
                in_house_products_used__c:
                    'Fevicryl Acrylic Colours - White 27, Sky Blue 63, Teal Blue 68, Fevicryl Acrylic Colours Pearl - Metallic Bronze 355, Fevicryl Mouldit, Fevicryl Fabric Glue, Fine Art Brushes ',
                level_of_difficulty__c: 'Advanced ',
                link_in_pil_tantra__c: null,
                name: 'ALARM CLOCK PHOTO FRAME',
                non_pil_product_price__c: 'To be included later',
                out_sourced_products_use__c:
                    'Plastic Container, Paper Cutter, Corrugated Sheet / Card Board Paper, Wooden Stick, OHP Sheet, CD Marker, Scissors, Clay Carving Tools, Colour Palette, Water Container, Colour Palette ',
                pil_product_price__c: 'To be included later',
                seasonality__c: 'General﻿',
                thumbnail_url__c: 'https://i.ibb.co/YyfjDdG/ALARM-CLOCK-PHOTO-FRAME.jpg',
                time_period__c: 'April - June',
                thumbnail_link__c: '',
                total_cost_of_making_the_article__c: 'To be included later',
                link_in_pil_tantra_url__c: 'https://i.ibb.co/YyfjDdG/ALARM-CLOCK-PHOTO-FRAME.jpg',
            },
        };
    }

    async componentDidMount() {
        try {
            await client
                .query({
                    query: gql(getUser),
                })
                .then(({ data }) => {
                    this.setState({
                        userData: data.user,
                    });
                });
        } catch (e) {
            console.error(e);
        }

        const { history } = this.props;
        const data =
            history.location.productData || JSON.parse(localStorage.getItem('productData'));

        if (data) {
            if (history.location.productData) {
                localStorage.setItem('productData', JSON.stringify(data));
            }

            this.setState({
                productData: data,
            });
        }

        const getUdata = async () => {
            const { productData, userData } = this.state;
            const { history } = this.props;

            const data = history.location.productData || productData;

            if (userData) {
                const getStarRatingQuery = `
                    SELECT id, Customer__c, Content_Categorization__c, name, Rating__c
                    FROM salesforce.Content_Categorization_Reviews__c
                    WHERE Content_Categorization__c = '${data.sfid}'
                    AND Customer__c = '${userData.sfid}'
                `;

                try {
                    const result = await getData(getStarRatingQuery);

                    if (result.result.length > 0) {
                        const rating = parseFloat(result.result[0].rating__c);
                        this.setState({ FCPRating: rating });
                    }
                } catch (e) {
                    console.error(getStarRatingQuery);
                    console.error(e);
                }
            }
        };

        // Call the function
        getUdata();

        this.setState({
            loading: false,
        });
    }

    openPage = (url) => {
        window.open(url, '_blank');
    };

    changeRating = async (newRating, data) => {
        const numericRating = parseFloat(newRating);
        const { userData } = this.state;
        this.setState({
            FCPRating: numericRating,
        });
        const result = await getData(
            `select id,Customer__c,Content_Categorization__c,name,Rating__c from salesforce.Content_Categorization_Reviews__c where Content_Categorization__c = '${data.sfid}' and Customer__c = '${userData.sfid}'`
        );
        if (result.result.length === 0) {
            await getData(
                `INSERT INTO salesforce.Content_Categorization_Reviews__c( Customer__c, Content_Categorization__c, name, Rating__c)
                VALUES('${userData.sfid}','${data.sfid}','${data.name}','${numericRating}') RETURNING id`
            ).then((resp) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Feedback is Submitted Successfully',
                    showConfirmButton: true,
                    confirmButtonColor: '#1a5c9a',
                });
            });
        } else {
            await getData(
                `UPDATE salesforce.Content_Categorization_Reviews__c SET Rating__c = '${numericRating}'
                WHERE Customer__c = '${userData.sfid}' AND Content_Categorization__c = '${data.sfid}' RETURNING id`
            ).then((resp) => {
                Swal.fire({
                    icon: 'success',
                    title: 'Feedback is Updated Successfully',
                    showConfirmButton: true,
                    confirmButtonColor: '#1a5c9a',
                });
            });
        }
    };

    render() {
        const { loading, productData, FCPRating } = this.state;
        const { history } = this.props;
        const data = history.location.productData ? history.location.productData : productData;

        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <Grid item xs={2} sm={2} md={2}>
                            <IconButton
                                color="inherit"
                                aria-label="Menu"
                                onClick={() => {
                                    history.goBack();
                                }}
                            >
                                <ArrowBackIcon />
                            </IconButton>
                        </Grid>
                        <Grid item xs={8} sm={8} md={8}>
                            <Typography variant="title" color="inherit" className="text-center">
                                Fevicryl Content Categorization
                            </Typography>
                        </Grid>
                    </Toolbar>
                </AppBar>
                {loading ? (
                    <Grid container alignItems="center" justify="center">
                        <Loader type="Audio" color="#00BFFF" height="50" width="50" />
                    </Grid>
                ) : (
                    <>
                        {/* {data && data.map((item) => {
                        return( */}
                        <>
                            <div className="fevicyrlDetails__outerBox row m-0">
                                <div className="col-lg-6 col-md-6 fevicyrlDetails__innerBox">
                                    <div className="d-flex justify-content-between">
                                        <div className="fevicyrlDetails__name">{data.name}</div>
                                        <div className="fevicyrlDetails__bookmark">
                                            <FaRegBookmark /> |{' '}
                                            <span
                                                onClick={() =>
                                                    this.openPage(data.thumbnail_link__c)
                                                }
                                            >
                                                {' '}
                                                <RiShareForward2Line />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <img src={data.link_in_pil_tantra_url__c} alt="img" />
                                        <div className="fevicyrlDetails__detailBox w-50">
                                            <p className="fevicyrlDetails__despTitle">
                                                In House Products Used -
                                            </p>
                                            <p className="fevicyrlDetails__info">
                                                {data.in_house_products_used__c}
                                            </p>
                                            <p className="fevicyrlDetails__despTitle">
                                                Out Sourced Products Use -
                                            </p>
                                            <p className="fevicyrlDetails__info">
                                                {data.out_sourced_products_use__c}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="fevicyrlDetails__InfoBoxs">
                                        {data.seasonality__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Seasonality - {data.seasonality__c}
                                            </div>
                                        )}
                                        {data.craft_category__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Craft Category - {data.craft_category__c}
                                            </div>
                                        )}
                                        {data.time_period__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Time Period - {data.time_period__c}
                                            </div>
                                        )}
                                        {data.difficulty_level__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Difficulty Level - {data.difficulty_level__c}
                                            </div>
                                        )}
                                        {data.institute__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Institute - {data.institute__c}
                                            </div>
                                        )}
                                        {data.art_form__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Art Form - {data.art_form__c}
                                            </div>
                                        )}
                                        {data.festival_generic__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Festival Generic - {data.festival_generic__c}
                                            </div>
                                        )}
                                        {data.is_best_out_of_waste__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Best Out Of Waste - {data.is_best_out_of_waste__c}
                                            </div>
                                        )}
                                        {data.hero_product_1__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Hero Product 1 - {data.hero_product_1__c}
                                            </div>
                                        )}
                                        {data.hero_product_2__c && (
                                            <div className="fevicyrlDetails__labelBox">
                                                {' '}
                                                Hero Product 2 - {data.hero_product_2__c}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 fevicyrlDetails__innerBox2">
                                    {/* <div className='fevicyrlDetails__amountBox'>
                                            <div className='row fevicyrlDetails__amountRow'>
                                                <div className='col-8 fevicyrlDetails__amountTitle'>PIL Product Price</div>
                                                <div className='col-4 fevicyrlDetails__amount'>{data.non_pil_product_price__c}</div>
                                            </div>
                                            <div className='row fevicyrlDetails__amountRow'>
                                                <div className='col-8 fevicyrlDetails__amountTitle'>Non-PIL Product Price</div>
                                                <div className='col-4 fevicyrlDetails__amount'>{data.pil_product_price__c}</div>
                                            </div>
                                            <div className='row m-0 fevicyrlDetails__amountTitle2'>
                                                <div className='col-8 fevicyrlDetails__amountTitle'>Total Cost of Making</div>
                                                <div className='col-4 fevicyrlDetails__amount'>{data.total_cost_of_making_the_article__c}</div>
                                            </div>
                                        </div> */}

                                    <Paper style={{ padding: 10, paddingTop: 10 }} square={true}>
                                        <Grid
                                            container
                                            direction="row"
                                            justify="space-around"
                                            alignItems="center"
                                            spacing={8}
                                        >
                                            <Grid item xs={4}>
                                                <p className="fevicyrlDetails__despTitle">
                                                    Did you like the article/ concept? Please rate
                                                </p>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <StarRatings
                                                    rating={FCPRating}
                                                    starRatedColor="gold"
                                                    numberOfStars={5}
                                                    changeRating={(newRating) =>
                                                        this.changeRating(newRating, data)
                                                    }
                                                    name="rating"
                                                    starDimension="20px"
                                                    starSpacing="2px"
                                                    starEmptyColor="#D3D3D3"
                                                />
                                            </Grid>
                                        </Grid>
                                        <hr />
                                        <Grid
                                            container
                                            direction="row"
                                            justify="space-around"
                                            alignItems="center"
                                            spacing={8}
                                        >
                                            <Grid item xs={8}>
                                                <Button
                                                    variant="contained"
                                                    fullWidth={true}
                                                    key="submit"
                                                    color="primary"
                                                    onClick={() =>
                                                        this.openPage(data.thumbnail_link__c)
                                                    }
                                                >
                                                    Click here for detailed document
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </div>
                            </div>
                        </>
                        {/* )
                    })} */}
                    </>
                )}
            </>
        );
    }
}
